module.exports = __webpack_public_path__ + "static/media/power-off.00247063.svg";